import { ChatbotPopupProps } from 'interfaces/components/chatbot/ChatbotPopup';
import ChatHeader from './ChatHeader';
import ChatArea from './ChatArea';
import ChatInput from './ChatInput';
import { useResizablePopup } from 'hooks/useResizablePopup';

const ChatbotPopup = ({
  isOpen,
  messages,
  inputValue,
  isLoading,
  showSuggestions,
  focusedIndex,
  chatAreaRef,
  popupRef,
  handleInputChange,
  handleSendMessage,
  handleKeyPress,
  handleKeyDown,
  handleSuggestionClick,
  handleSuggestedQuestionClick,
  chatbotData,
  autocompletions
}: ChatbotPopupProps) => {
  const { widthPct, heightPct, onResizeStart, bubbleMaxWidth } = useResizablePopup({
    initialWidthPx: 480,
    initialHeightPx: 560,
    minWidthPx: 420,
    minHeightPx: 420,
    leftOffsetPx: 80,
    bottomOffsetPx: 100,
    maxWidthPct: 80,
    maxHeightPct: 80
  });
  return (
    <div
      ref={popupRef}
      className={`fixed bottom-[100px] left-20 p-6 bg-white dark:bg-gray-900 rounded-2xl z-[9998] select-none ${
        isOpen
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      }`}
      style={{
        width: `${widthPct}vw`,
        height: `${heightPct}vh`,
        maxWidth: '80vw',
        maxHeight: '80vh',
        boxShadow: '0px 4px 7.6px 0px #00000021',
        filter: 'drop-shadow(0 4px 7.6px rgba(0, 0, 0, 0.13))'
      }}
    >
      <div className='flex flex-col h-full gap-4'>
        <ChatHeader />

        <ChatArea
          messages={messages}
          onSuggestedQuestionClick={handleSuggestedQuestionClick}
          chatAreaRef={chatAreaRef}
          isLoading={isLoading}
          chatbotData={chatbotData}
          bubbleMaxWidth={bubbleMaxWidth}
        />

        <ChatInput
          inputValue={inputValue}
          onInputChange={handleInputChange}
          onSendMessage={handleSendMessage}
          onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDown}
          isLoading={isLoading}
          showSuggestions={showSuggestions}
          focusedIndex={focusedIndex}
          onSuggestionClick={handleSuggestionClick}
          autocompletions={autocompletions}
        />
      </div>

      {/* Top-right resize handle */}
      <button
        type='button'
        aria-label='Resize chatbot'
        onMouseDown={onResizeStart}
        className='absolute -top-2 -right-2 w-4 h-4 bg-transparent cursor-nesw-resize'
      >
        <span className='block w-full h-full border-t-2 border-r-2 border-gray-400 dark:border-gray-500 rounded-sm' />
      </button>
    </div>
  );
};

export default ChatbotPopup;
